import { Component, OnInit, TemplateRef, ViewChild, Output, EventEmitter,Input } from '@angular/core';
import { NgbModal, NgbModalRef, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { PrixService, Prix } from '../prix.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-croud',
  templateUrl: './croud.component.html',
  styleUrls: ['./croud.component.scss']
})
export class CroudComponent implements OnInit {
    @ViewChild('modalLG') modalTemplate!: TemplateRef<any>;
    @Output() prixAdded = new EventEmitter<void>();
    @Output() prixUpdated = new EventEmitter<Prix>();
    @Output() prixError = new EventEmitter<string>();
    @Input() modalType: 'ajouter' | 'update' | 'etat' = 'ajouter';
    @Input() stationId?: number;
    @Input() clientIdFromParent?: number;

    private modalRef!: NgbModalRef;
    selectedPrix: Prix | null = null;
    priceName: string = '';
    idStation: number | null = null;
    clientId: number | null = null;
    isLoading: boolean = false;
    showErrorOnce: boolean = false;

    constructor(
        private modalService: NgbModal,
        private prixService: PrixService,
        private toastr: ToastrService
    ) {}

    ngOnInit(): void {
        this.loadUserData();
    }

    loadUserData(): void {
        if (this.stationId) {
            this.idStation = this.stationId;
        } else {
            const user = localStorage.getItem('currentUser');
            if (user) {
                const currentUser = JSON.parse(user);
                if (currentUser?.stations?.length > 0) {
                    this.idStation = currentUser.stations[0].id;
                } else {
                    this.toastr.error('Aucune station trouvée. Veuillez créer une station.', 'Erreur');
                    return;
                }
            } else {
                this.toastr.error('Utilisateur non connecté.', 'Erreur');
                return;
            }
        }

        if (this.clientIdFromParent !== undefined) {
            this.clientId = this.clientIdFromParent;
        } else {
            const user = localStorage.getItem('currentUser');
            if (user) {
                const currentUser = JSON.parse(user);
                this.clientId = currentUser.id;
            } else {
                this.clientId = null;
            }
        }
    }

    openModal(type: 'ajouter' | 'update' | 'etat', prix?: Prix): void {
        if (this.idStation === null) {
            this.toastr.error('Impossible d\'ouvrir le modal : aucune station disponible.', 'Erreur');
            return;
        }
        this.modalType = type;
        this.selectedPrix = prix || null;
        if (type === 'ajouter') {
            this.priceName = '';
            this.showErrorOnce = false;
        } else if (type === 'update' && this.selectedPrix) {
            this.priceName = this.selectedPrix.libelle || '';
            this.showErrorOnce = false;
        }
        const options: NgbModalOptions = {
            size: 'ml',
            centered: true,
            backdrop: 'static',
            keyboard: false,
            animation: false
        };
        this.modalRef = this.modalService.open(this.modalTemplate, options);
    }

    checkLengthOnce(): void {
        if (!this.showErrorOnce && this.priceName.length > 200) {
            this.showErrorOnce = true;
            console.log('priceName length exceeded 200:', this.priceName.length);
        } else if (this.priceName.length <= 200) {
            this.showErrorOnce = false;
        }
    }

    savePrix(): void {
        if (this.idStation === null) {
            this.toastr.error('Aucune station disponible pour effectuer cette action.', 'Erreur');
            return;
        }
        if (this.priceName.length > 200) {
            this.toastr.error('Le nom du prix ne doit pas dépasser 200 caractères.', 'Erreur');
            return;
        }

        if (this.modalType === 'ajouter' && !this.priceName.trim()) {
            this.toastr.error('Le nom du prix est requis.', 'Erreur');
            return;
        }

        if (this.modalType === 'ajouter' && this.priceName.trim()) {
            this.isLoading = true;
            const newPrix: Prix = {
                libelle: this.priceName.trim(),
                statut: true,
                station_id: this.idStation,
                client_id: this.clientId
            };
            this.prixService.addPrix(newPrix, this.idStation).subscribe({
                next: (createdPrix) => {
                    this.toastr.success('Prix ajouté avec succès', 'Succès');
                    this.prixAdded.emit();
                    this.isLoading = false;
                    this.modalRef.close('added');
                },
                error: (err) => {
                    this.prixError.emit('add-failed');
                    this.toastr.error('Erreur lors de l\'ajout du prix', 'Erreur');
                    console.error('Erreur lors de l\'ajout du prix:', err);
                    this.isLoading = false;
                }
            });
        } else if (this.modalType === 'update' && this.selectedPrix && this.priceName.trim()) {
            this.isLoading = true;
            const updatedPrix: Prix = {
                id: this.selectedPrix.id,
                libelle: this.priceName.trim(),
                statut: this.selectedPrix.statut,
                station_id: this.idStation,
                client_id: this.clientId
            };
            this.prixService.updatePrix(updatedPrix, this.idStation).subscribe({
                next: (response) => {
                    const updated = { ...this.selectedPrix, libelle: this.priceName.trim() } as Prix;
                    this.toastr.success('Prix modifié avec succès', 'Succès');
                    this.prixUpdated.emit(updated);
                    this.isLoading = false;
                    this.modalRef.close('updated');
                },
                error: (err) => {
                    this.prixError.emit('update-failed');
                    this.toastr.error('Erreur lors de la modification du prix', 'Erreur');
                    console.error('Erreur lors de la modification du prix:', err);
                    this.isLoading = false;
                }
            });
        } else if (this.modalType === 'etat' && this.selectedPrix) {
            this.isLoading = true;
            const newStatut = !this.selectedPrix.statut;
            this.prixService.updatePrixEtat(this.selectedPrix.id!, newStatut, this.idStation).subscribe({
                next: (updatedPrix) => {
                    const toggled = { ...this.selectedPrix, statut: newStatut } as Prix;
                    this.toastr.success(`Prix ${this.selectedPrix?.libelle} ${newStatut ? 'activé' : 'désactivé'} avec succès`, 'Succès');
                    this.prixUpdated.emit(toggled);
                    this.isLoading = false;
                    this.modalRef.close('toggled');
                },
                error: (err) => {
                    this.prixError.emit('toggle-failed');
                    this.toastr.error('Erreur lors de la mise à jour de l\'état', 'Erreur');
                    console.error('Erreur lors de la mise à jour de l\'état:', err);
                    this.isLoading = false;
                }
            });
        }
    }

    cancelModal(): void {
        this.toastr.info('Action annulée', 'Information');
        this.isLoading = false;
        this.modalRef.dismiss('cancel');
    }
}
